import { periodAPI } from 'api/period';
import { FindAllPeriodDto } from 'dto/period';
import { useEffect } from 'react';
import { useQuery } from 'react-query';
import { QUERY_KEY } from 'utils/enums';

type PropsType = {
  filters: FindAllPeriodDto;
};

export function useFindAllPeriod(props: PropsType) {
  const query = useQuery({
    queryKey: QUERY_KEY.FIND_ALL_PERIOD,
    queryFn: () => periodAPI.findAll(props.filters),
  });

  useEffect(() => {
    query.refetch();
  }, [props.filters]);

  return {
    query: query,
    count: query.data?.count ?? 0,
    rows: query.data?.rows ?? [],
    loading: query.isLoading || query.isFetching || query.isRefetching,
  };
}
